import React from 'react';

const skills = [
    ['Workflow Automation', 'bx bx-flow-chart'],
    ['n8n', 'bx bx-network-chart'],
    ['Telegram Bot Development', 'bx bxl-telegram'],
    ['Prompt Engineering', 'bx bx-bulb'],
    ['RAG Systems', 'bx bx-brain'],
    ['FastAPI', 'bx bx-fast-forward'],
    ['Python', 'bx bxl-python'],
    ['Java', 'bx bxl-java'],
    ['C++', 'bx bxl-c-plus-plus'],
    ['Data Structures', 'bx bx-shape-triangle'],
    ['Algorithms', 'bx bx-sort-alt-2'],
    ['Problem Solving', 'bx bx-brain'],
    ['Communication', 'bx bx-message-dots'],
    ['Teamwork', 'bx bxl-microsoft-teams'],
    ['Continuous Learning', 'bx bx-radar']
];

const Soft = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title bold">Automation, AI & Core Skills</h3>
            <div className="skills__box">
                {skills.map(([name, icon]) => (
                    <div className="skills__data" key={name}>
                        <i className={icon}></i>
                        <h3 className="skills__name">{name}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Soft;
